import { render } from "./formGroup.vue?vue&type=template&id=f9956494"
import script from "./formGroup.vue?vue&type=script&lang=js"
export * from "./formGroup.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__